import { environment } from '../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

const BASE_URL = `${environment.localSbxUrl}${environment.harpUtilAPI}`;
@Injectable()
export class SelectDestinationService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  getSelectDestinationLink() {
    return this.http.get(
      BASE_URL + environment.selectDestinationEndpoint,
      this.httpOptions,
    );
  }
}
